import { GeofenceDto } from 'api/geofences/models/GeofenceDto';
import GeofencesService from 'api/geofences/GeofencesService';
import { Col, Row } from 'react-flexbox-grid';
import ScreenTitle from 'common/components/screenTitle/ScreenTitle'
import { CompactPageLayout } from 'common/components/compactPageLayout';
import styles from './GeofenceScreen.module.scss';
import Loading from 'common/services/Loading';
import Logger from 'common/services/Logger';
import { LOGGER_LOG_TYPE } from 'Config';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import { Reducers } from 'store/types';
import { useSelector } from 'react-redux';
import Label from 'common/components/label/Label';
import FormItem from 'common/components/formItem/FormItem';
import InputController from 'common/components/input/InputController';
import InputError from 'common/components/inputError/InputError';
import { useForm } from 'react-hook-form';
import Utils from 'common/services/Utils';
import InputGroupController from 'common/components/inputGroup/InputGroupController';
import Button from 'common/components/button/Button';
import ZoomLevelControl from 'common/components/maps/ZoomLevelControl';
import DrawTools, { LocationArea } from 'common/components/maps/DrawTools';
import { Circle, MapContainer, Marker, TileLayer, useMapEvents } from 'react-leaflet';
import QuestionYesNo from 'common/components/questionYesNo/QuestionYesNo';
import { UserProfile } from 'api/account/models/UserProfile';
import UsersService from 'api/users/UsersService';
import Tabs, { TabItem } from 'common/components/tabs/Tabs';
import Box from 'common/components/box/Box';
import ChargesTab from './components/charges/ChargesTab';

import { addressFormat } from 'common/services/GeoLocator';
import L, { LatLngExpression } from 'leaflet';
import AsyncSelect from 'react-select/async';
import colors from 'styles/export/colors.module.scss';
import { FaInfoCircle } from 'react-icons/fa';
import ReactTooltip from 'react-tooltip';
import VisitsReportScreenContent from 'screens/visits-report/components/content/VisitsReportScreenContent';

export const markerIcon = L.icon({
    iconSize: [25, 41],
    iconAnchor: [10, 41],
    popupAnchor: [2, -40],
    iconUrl: 'https://unpkg.com/leaflet@1.7/dist/images/marker-icon.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.7/dist/images/marker-shadow.png'
});

export type AddressOption = {
    label: string;
    lat: number;
    long: number;
    address: string;
}


export type Types = 'edit' | 'details' | 'new';


const GeofenceScreen = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const location = useLocation();
    const { addToast } = useToasts();
    const { type, itemId } = useParams<{ type: Types, itemId: string }>();
    const [item, setItem] = useState<GeofenceDto>();
    const [isDetails, setIsDetails] = useState<boolean>(type == 'details');
    const form = useForm<GeofenceDto>({
        defaultValues: {
            name: '',
            latitude: undefined,
            longitude: undefined,
            radius: undefined,
            zoom: undefined,
            address: undefined
        }
    });
    const { handleSubmit, setValue, errors } = form;
    const [area, setArea] = useState<LocationArea>();
    const [position, setPosition] = useState<GeolocationPosition>();
    const [zoomDefault, setZoomDefault] = useState<number>(12);
    const [refresh, setRefresh] = useState<number>(1);
    const [dialogDeleteItemIsOpen, setDialogDeleteItemIsOpen] = useState<boolean>(false);
    const userProfile = useSelector<Reducers, UserProfile | null>(state => state.authentication.profile);
    const hasUsersWritePolicy = UsersService.hasPolicies(userProfile?.policies || [], ['SETTINGUP_COST_CENTER_WRITE']);
    const hasUsersGPSWritePolicy = UsersService.hasPolicies(userProfile?.policies || [], ['SETTINGUP_GPS_READ']);

    const tabFromUrl = new URLSearchParams(location.search).get('tab');
    let lastTab = tabFromUrl ?? localStorage.getItem('GEOFENCES_DETAILS_TAB');
    if (!hasUsersGPSWritePolicy && lastTab == 'visits-report') {
        lastTab = null;
    }
    const [activeTabId, setActiveTabId] = useState<string>(lastTab ?? 'charges');


    const [markerPosition, setMarkerPosition] = useState<LatLngExpression | null>(null)
    const [render, setReRender] = useState(0)
    const [geofenceHasCharges, setGeofenceHasCharges] = useState<boolean>(false);
    const [geofenceByDraw, setGeofenceByDraw] = useState<boolean>(false);
    const timerId = useRef<NodeJS.Timeout | null>(null)

    const getData = async () => {
        try {
            if (itemId) {
                Loading.show();
                const result = await GeofencesService.getById(itemId);
                setItem(result);
                setGeofenceHasCharges(result.hasCharges ?? false);

                Object.entries(result).forEach(([key, value]) => setValue(key as keyof GeofenceDto, value));
                if (result.latitude && result.longitude && result.radius) {
                    const areaAux = { latitude: result.latitude, longitude: result.longitude, mRadius: result.radius, radius: result.radius };
                    setMarkerPosition({ lat: result.latitude, lng: result.longitude })
                    onCreateArea(areaAux);
                }
                setZoomDefault(result.zoom ?? zoomDefault);
                onChangeCoordinates();

                Loading.hide();
            }
        } catch (error) {
            Logger.error(LOGGER_LOG_TYPE.GEOFENCES, `Couldn't get geogences information `, error);
            addToast(t('common.messages.error_load_info'), { appearance: 'error' });
        }
    }

    useEffect(() => {
        getData();
        setIsDetails(type == 'details');
        if (!localStorage.getItem('GEOFENCES_DETAILS_TAB') && type == 'edit') {
            setActiveTabId('geofences');
        }
        //navigator.geolocation.getCurrentPosition((x: GeolocationPosition) => setCurrentPosition(x));
    }, [itemId, type]);


    useEffect(() => {
        if (activeTabId == 'geofences') {
            getData();
        }
    }, [activeTabId]);


    useEffect(() => {
        if (item) {
            form.reset({
                name: item.name,
                latitude: item.latitude,
                longitude: item.longitude,
                radius: item.radius,
                zoom: item.zoom,
                address: item.address,
                minimumStayTime: item.minimumStayTime
            });
            if (item.latitude && item.longitude && item.radius) {
                onCreateArea({
                    latitude: item.latitude,
                    longitude: item.longitude,
                    mRadius: item.radius,
                    radius: item.radius
                });
            }
        }
    }, [item]);

    const navigateTo = (type?: string, id?: string) => {
        if (type) {
            history.push(`/geofences/${type}/${id}`);
        } else {
            history.push(`/geofences`);
        }
    }

    const onGoBack = () => {
        if (!!itemId) {
            isDetails ? navigateTo() : navigateTo('details', itemId);
        } else {
            history.goBack();
        }
    }

    const onSubmit = async (formData: any) => {
        try {
            const model: GeofenceDto = {
                id: itemId ?? null,
                name: formData.name,
                latitude: formData.latitude ?? undefined,
                longitude: formData.longitude ?? undefined,
                radius: formData.radius ?? undefined,
                zoom: formData.zoom ?? zoomDefault,
                address: formData.address ?? undefined,
                rowVersion: item?.rowVersion,
                minimumStayTime: formData.minimumStayTime ?? 1
            };

            if ((model.radius ?? 0) > 100000) {
                addToast(t('common.errors.max_geofence_value_100'), { appearance: 'warning' });
                return;
            }

            Loading.show();

            if (itemId) {
                await GeofencesService.update(model)
                navigateTo('details', itemId)
            } else {
                const id = await GeofencesService.create(model);
                navigateTo('details', id)
            }

            Loading.hide();
            addToast(t('common.messages.record_save_success'), { appearance: 'success' });
        } catch (error) {
            addToast(t('common.messages.record_save_error'), { appearance: 'error' });
            Logger.error(LOGGER_LOG_TYPE.GEOFENCES, `Couldn't update the stopping areas with id: ${itemId}`, error);
            Loading.hide();
        }
    }

    const removeItem = async (a?: GeofenceDto) => {
        setDialogDeleteItemIsOpen(false);
        if (!a) return;

        try {
            Loading.show();
            await GeofencesService.remove(a);
            addToast(t('common.messages.record_delete_success'), { appearance: 'success' });
            navigateTo();
        } catch (error) {
            addToast(t('common.messages.record_delete_error'), { appearance: 'error' });
        } finally {
            Loading.hide();
        }
    };

    const onError = async () => {
        addToast(t('common.messages.validate_form'), { appearance: 'warning' });
    }

    const onCreateArea = (a: LocationArea) => {
        setGeofenceByDraw(true);

        setArea(a);
        setValue('latitude', a.latitude);
        setValue('longitude', a.longitude);
        setValue('radius', a.mRadius);
    }

    const setCurrentPosition = (p: GeolocationPosition) => {
        setPosition(p);
        setRefresh(refresh + 1);
    }

    const onChangeCoordinates = () => {
        if (form.getValues('latitude') && form.getValues('longitude')) {
            setCurrentArea(form.getValues('latitude')!, form.getValues('longitude')!)
        }
    }
    
    const promiseOptions = (inputValue: string, callback: (options: AddressOption[]) => void) => {

        if (timerId.current) clearTimeout(timerId.current);

        timerId.current = setTimeout(async () => {
            const result = await onSearchAddress(inputValue);
            callback(result);
        }, 500);
    }

    const onSearchAddress = async (value: string) => {
        try {
            const res: any = await GeofencesService.searchByAddress(value ?? '');
            if (!res || res.length == 0) return []

            return res.map((r: any) => (
                { label: addressFormat(r, r.lat, r.lon), lat: r.lat, long: r.lon, value: `${r.lat},${r.lon}`, address: addressFormat(r, r.lat, r.lon) }
            ))
        } catch (e) {
            addToast(t('common.messages.error_load_info'), { appearance: 'error' });
        }

    }

    const setCurrentArea = (lat: number, lng: number) => {
        setMarkerPosition([lat, lng])

        if (form.getValues('radius')) {
            setArea({ latitude: lat, longitude: lng, mRadius: form.getValues('radius') ?? 0, radius: form.getValues('radius') ?? 0 });
        }

        const p: GeolocationPosition = {
            coords: {
                latitude: lat,
                longitude: lng,
                accuracy: 0,
                altitude: null,
                altitudeAccuracy: null,
                heading: null,
                speed: null
            },
            timestamp: Date.now()
        };
        setCurrentPosition(p);
        setZoomDefault(zoomDefault);

        form.setValue('latitude', lat);
        form.setValue('longitude', lng);
    }

    const visitsReportTab = () => (<VisitsReportScreenContent geofenceId={itemId}
        onNavigate={() => {
            localStorage.setItem('GEOFENCES_DETAILS_TAB', activeTabId);
        }}
    />)


    function LocationMarker() {
        const map = useMapEvents({
            async click(e) {
                if (isDetails) return;

                if (geofenceByDraw && area) {
                    setGeofenceByDraw(false);
                    setCurrentArea(area?.latitude, area?.longitude)
                    return;
                }

                try {
                    const res: any = await GeofencesService.searchByLatLong(e.latlng.lat, e.latlng.lng)
                    setValue('address', addressFormat(res, res.lat!, res.lon!))

                } catch (e) {
                    addToast(t('common.messages.error_load_info'), { appearance: 'error' });
                } finally {
                    setCurrentArea(e.latlng.lat, e.latlng.lng)

                }
            },

        })

        return markerPosition === null ? null : (
            <Marker position={markerPosition} icon={markerIcon}>
            </Marker>
        )
    }

    const renderMap = () => {
        return <>
            <MapContainer
                key={`map_${refresh}`}
                center={[area ? area.latitude : position?.coords?.latitude ?? 52.516316, area ? area.longitude : position?.coords?.longitude ?? 13.377825]}
                maxZoom={18} minZoom={6} zoom={zoomDefault} scrollWheelZoom={true} zoomSnap={0.1} zoomDelta={0.5} className={styles.map}>
                {zoomDefault && <ZoomLevelControl onZoomChange={zoom => { setZoomDefault(zoom); setValue('zoom', zoom); }} />}
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

                {area ? <Circle center={[area.latitude, area.longitude]} radius={area.mRadius}></Circle> :
                    (isDetails ? <></> : <DrawTools onCreated={onCreateArea} />)
                }
                <LocationMarker />
            </MapContainer>
        </>
    }


    const geofenceTab = () => (
        <form onSubmit={handleSubmit(onSubmit, onError)}>
            <Box className={styles.box} >
                <Row>
                    <Col xs={12}>
                        <FormItem>
                            <Label className={styles.label}>
                                {t('geofences.list.name')}
                                {!isDetails ? '*' : ''}
                            </Label>
                            <InputController
                                name="name"
                                form={form as any}
                                autoComplete="off"
                                disabled={isDetails}
                                placeholder={t('geofences.list.name')}
                                rules={{
                                    required: !(type === 'details'),
                                    validate: value => !Utils.isStringNullOrEmpty(value),
                                    maxLength: 250,
                                }}
                            />
                            <InputError error={errors.name} maxLength={250} />
                        </FormItem>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12}>
                        <FormItem>
                            <Label className={styles.label}>
                                {t('geofences.list.address')}

                            </Label>
                            <InputController
                                name="address"
                                form={form as any}
                                autoComplete="off"
                                disabled={isDetails}
                                placeholder={t('geofences.list.address')}
                                rules={{
                                    required: false,
                                    maxLength: 250,
                                }}
                            />
                            <InputError error={errors.address} maxLength={250} />
                        </FormItem>
                    </Col>
                </Row>
                <Row key={render}>
                    <Col md={6} xl={3}>
                        <Label className={styles.label}>
                            {t('geofences.latitude')}
                            {!isDetails ? '*' : ''}
                        </Label>
                        <InputController
                            name={'latitude'}
                            type="number"
                            min="0"
                            form={form as any}
                            autoComplete="off"
                            disabled={isDetails}
                            placeholder={t('geofences.latitude')}
                            rules={{ required: !isDetails }}
                            onKeyPress={(e: any) => {
                                if (e.key === 'Enter') {
                                    onChangeCoordinates();
                                }
                            }}
                            onBlur={() => {
                                onChangeCoordinates();
                            }}
                        />
                        <InputError error={errors['latitude']} />
                    </Col>
                    <Col md={6} xl={3}>
                        <Label className={styles.label}>
                            {t('geofences.longitude')}
                            {!isDetails ? '*' : ''}
                        </Label>
                        <InputController
                            name={'longitude'}
                            type="number"
                            min="0"
                            form={form as any}
                            autoComplete="off"
                            disabled={isDetails}
                            placeholder={t('geofences.longitude')}
                            rules={{ required: !isDetails }}
                            onKeyPress={(e: any) => {
                                if (e.key === 'Enter') {
                                    onChangeCoordinates();
                                }
                            }}
                            onBlur={() => {
                                onChangeCoordinates();
                            }}
                        />
                        <InputError error={errors['longitude']} />
                    </Col>
                    <Col md={6} xl={3}>
                        <Label className={styles.label}>
                            {t('geofences.radius')}
                            {!isDetails ? '*' : ''}
                        </Label>
                        <InputGroupController
                            name={'radius'}
                            text={t('common.meters')}
                            type="number"
                            min="0"
                            form={form as any}
                            autoComplete="off"
                            disabled={isDetails}
                            placeholder={t('geofences.radius')}
                            rules={{ required: !isDetails }}
                            onKeyPress={(e: any) => {
                                if (e.key === 'Enter') {
                                    onChangeCoordinates();
                                }
                            }}
                            onBlur={() => {
                                onChangeCoordinates();
                            }}
                        />
                        <InputError error={errors['radius']} />
                    </Col>
                    <Col md={6} xl={3}>
                        <FormItem>
                            <Label className={styles.label}>
                                {t('geofences.list.minimum_stay_time')}
                                {!isDetails ? '*' : ''}
                                <FaInfoCircle data-tip={t('geofences.list.minimum_stay_time_tooltip')} data-for={'minimumStayTimeTooltipId'} style={{ marginLeft: '0.5rem' }} />

                            </Label>
                            <ReactTooltip id={'minimumStayTimeTooltipId'} type="dark" effect="solid" />

                            <InputController
                                name="minimumStayTime"
                                form={form as any}
                                autoComplete="off"
                                disabled={isDetails}
                                type="number"
                                placeholder={t('geofences.list.minimum_stay_time')}
                                rules={{
                                    required: true,
                                }}
                                min={1}
                                step={1}
                            />
                            <InputError error={errors.minimumStayTime} />
                        </FormItem>
                    </Col>
                </Row>
                {!isDetails && <hr className={styles.hr}></hr>}
                {!isDetails && <Row>
                    <Col xs={8}>
                        <Label className={styles.label}>
                            {t('geofences.search_by_address')}
                        </Label>
                        <AsyncSelect loadOptions={promiseOptions} onChange={data => {
                            if (data) {
                                setCurrentArea(data.lat, data.long)
                                form.setValue('address', data.address)
                            }
                        }}
                            noOptionsMessage={() => t('common.no_options')}
                            loadingMessage={() => t('common.searching')}
                            placeholder={t('geofences.search_by_address')}
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    backgroundColor: colors.white,
                                    borderRadius: '20px !important',
                                    border: state.isFocused ? `1px solid ${colors.success}` : `1px solid ${colors.mercury}`,
                                    boxShadow: 'none',
                                    ':hover': {
                                        borderColor: state.isFocused ? colors.success : colors.mercury,
                                    },
                                    zIndex: 0
                                }),
                                menuPortal: base => ({
                                    ...base,
                                    zIndex: 9999
                                }),
                                placeholder: base => ({
                                    ...base,
                                    color: colors.frenchGray,
                                    opacity: 0.54,
                                }),
                                valueContainer: base => ({
                                    ...base,
                                    padding: '5.75px 1rem',
                                    justifyContent: 'initial',
                                    zIndex: 0
                                }),
                                option: (base, state) => ({
                                    ...base,
                                    color: state.isSelected ? colors.white : colors.black,
                                    backgroundColor: state.isSelected ? colors.primaryDark : colors.white,
                                    ':hover': {
                                        backgroundColor: colors.lightGrayishBlue,
                                        color: colors.black
                                    },
                                }),
                                singleValue: base => ({
                                    ...base,
                                    color: colors.lightblack,
                                }),
                                multiValueLabel: base => ({
                                    ...base,
                                    backgroundColor: colors.solitude,
                                    color: colors.black,
                                }),
                                multiValueRemove: base => ({
                                    ...base,
                                    backgroundColor: colors.solitude,
                                    color: colors.black,
                                }),
                                indicatorSeparator: base => ({
                                    ...base,
                                    width: '1px',
                                    backgroundColor: colors.mercury
                                }),
                            }}
                        />
                    </Col>
                </Row>}
                <Col xs={12}>
                    <Row className={styles.map}>{renderMap()}</Row>
                </Col>
                <Row>
                    <div className={styles.buttons}>
                        <Button
                            preset={'secondary'}
                            type="button"
                            onClick={() => onGoBack()}
                            text={t('common.cancel')}
                        />

                        {!!itemId && isDetails && hasUsersWritePolicy && (
                            <Button
                                type="button"
                                text={t('common.remove')}
                                preset={'danger'}
                                isDisabled={geofenceHasCharges}
                                disabledMessage={geofenceHasCharges ? t('geofences.cant_delete_has_charges') : undefined}
                                onClick={() => setDialogDeleteItemIsOpen(true)}
                            />
                        )}
                        {itemId && isDetails && hasUsersWritePolicy && (
                            <Button
                                type={'button'}
                                text={t('common.edit')}
                                isDisabled={geofenceHasCharges}
                                disabledMessage={geofenceHasCharges ? t('geofences.cant_update_has_charges') : undefined}
                                onClick={() => {
                                    navigateTo('edit', itemId);
                                }}
                            />
                        )}

                        {!isDetails && hasUsersWritePolicy && (
                            <Button
                                text={t('common.save')}
                                onClick={handleSubmit(onSubmit)}
                            />
                        )}

                        {item && (
                            <QuestionYesNo
                                message={t('common.messages.remove_record')}
                                isVisible={dialogDeleteItemIsOpen}
                                onYes={() => removeItem(item)}
                                onNo={() => setDialogDeleteItemIsOpen(false)}
                            />
                        )}
                    </div>
                </Row>
            </Box>
        </form>
    );

    const chargeTab = () => (<ChargesTab geofenceId={itemId}
        onNavigate={() => {
            localStorage.setItem('GEOFENCES_DETAILS_TAB', activeTabId);
        }}
    />);


    const getPageTitle = () => {
        return type === 'new' ? t('geofences.new') : type === 'edit' ? t('geofences.edit') : form.watch('name');
    }

    const tabs: TabItem[] = [
        {
            id: 'charges',
            title: t('charges.title'),
            content: chargeTab()
        },
        {
            id: 'geofences',
            title: t('geofences.title'),
            content: geofenceTab()
        }];

    if (hasUsersGPSWritePolicy) {
        tabs.splice(1, 0, {
            id: 'visits-report',
            title: t('visits_report.list.title'),
            content: visitsReportTab()
        })
    }

    return (
        <ScreenTitle title={getPageTitle()}>
            <CompactPageLayout
                title={getPageTitle() as string}
                contentAreaClassName={styles.contentArea}
                onBack={() => {
                    localStorage.removeItem('GEOFENCES_DETAILS_TAB');
                    history.push('/geofences');
                }}
            >
                {type !== 'new' && <Tabs
                    items={tabs}
                    activeTabId={activeTabId}
                    onChange={(tId: string) => {
                        setActiveTabId(tId);
                    }}
                />}
                {type === 'new' && geofenceTab()}
            </CompactPageLayout>
        </ScreenTitle>
    );

}

export default GeofenceScreen